// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_lj-0";
export var buttonContainer = "_lj-3";
export var cancelButton = "_lj-4";
export var headerSection = "_lj-6";
export var headerTitle = "_lj-9";
export var messageSideLeft = "_lj-1";
export var messageSideRight = "_lj-2";
export var orderNumberContainer = "_lj-7";
export var orderNumberLabel = "_lj-8";
export var submitButton = "_lj-5";